import ico from "../../../assets/img/projects/People/people-ico.png";

export default function Palette() {
  return (
    <div className="people-palette">
      <div className="colo-grid">
        <div></div>
        <div></div>
        <div></div>
      </div>
      <img src={ico} className="people-ico"></img>
    </div>
  );
}
